import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FiUser, FiShoppingBag, FiSearch, FiMenu } from 'react-icons/fi';
import { clientConfig } from '../../../../../config';
import * as translator from '../../../../../utils/translator';
import logo_v2025 from '../../../../../images/logo_v2025.png';

const CareProfileHeader = () => {
	const { country } = useParams<{ country: string }>();
	const navigate = useNavigate();
	const homeUrlPrefix = translator.getCMSUrlPrefixByLocale(translator.getLocaleByCountry(country));

	return (
		<header id="care-profile-header" className="bg-white flex items-center justify-between lg:justify-center px-4 lg:px-0 py-3 lg:py-[25px]">
			<div id="care-profile-header-account-cart" className="flex items-center gap-x-3 lg:hidden">
				<button
					id="care-profile-header-account"
					type="button"
					aria-label="Account"
					onClick={() => navigate(`/${country}/account/my-orders`)}
					className="flex items-center justify-center w-[26px] h-[26px] rounded-full bg-[#0a9281] text-white border-none"
				>
					<FiUser size={14} />
				</button>
				<div id="care-profile-header-cart" className="relative flex items-center justify-center w-6 h-6 text-[#616975]">
					<FiShoppingBag size={20} />
					<span className="absolute -top-1 -right-1 w-[9px] h-[9px] rounded-full bg-[#ef4747]" />
				</div>
			</div>

			<img
				src={logo_v2025}
				alt="DoktorABC"
				className="h-[20px] w-auto lg:h-[29px] lg:w-[178px] cursor-pointer"
				onClick={() => (window.location.href = `${clientConfig.MAIN_WEBSITE_URL}/${homeUrlPrefix}`)}
			/>

			<div id="care-profile-header-search-menu" className="flex items-center gap-x-3 lg:hidden">
				<div id="care-profile-header-search" className="flex items-center justify-center w-6 h-6 text-[#98a0af]">
					<FiSearch size={20} />
				</div>
				<div id="care-profile-header-menu" className="flex items-center justify-center w-6 h-6 text-[#98a0af]">
					<FiMenu size={20} />
				</div>
			</div>
		</header>
	);
};

export default CareProfileHeader;
